<template>
  <button class="style-button border-0" type="button" :disabled="disabled">
    {{ title }}
  </button>
</template>

<script>
export default {
  name: "SmallDefaultButton",
  props: {
    title: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.style-button {
  background-color: $text-blue;
  color: $white-color;
  height: 45px;
  width: 100px;
  font-size: 14px;
  transition: 0.3s;
  border-radius: 10px;
  // width: 20%;
}
.style-button:hover {
  opacity: 0.8;
}
.style-button:active {
  box-shadow: 3px 2px 22px 1px rgba(134, 134, 134, 0.24);
  transform: scale(1.02, 1.02);
}

button:disabled,
button[disabled] {
  background-color: #979797;
}
</style>
